import { api } from '../../api/api';
import {
  PAYMENT_REQUEST, GET_PAYMENT_DASHBOARD_SUCCESS, GET_PAYMENTS_SUCCESS,
  ADD_PAYMENT_SUCCESS, UPDATE_PAYMENT_SUCCESS, DELETE_PAYMENT_SUCCESS,
} from '../constant';

export const getPaymentDashboard = (userId) => async (dispatch) => {
  dispatch({ type: PAYMENT_REQUEST });
  try {
    const res = await api.get(`/payment/dashboard/${userId}`);
    dispatch({ type: GET_PAYMENT_DASHBOARD_SUCCESS, payload: res.data });
  } catch (e) {}
};

export const getPayments = (userId, opts = {}) => async (dispatch) => {
  dispatch({ type: PAYMENT_REQUEST });
  try {
    const params = new URLSearchParams();
    if (opts.storeIds?.length) params.set('storeIds', opts.storeIds.join(','));
    const q = params.toString();
    const url = q ? `/payment/list/${userId}?${q}` : `/payment/list/${userId}`;
    const res = await api.get(url);
    dispatch({ type: GET_PAYMENTS_SUCCESS, payload: res.data.payments });
  } catch (e) {}
};

export const addPayment = (data) => async (dispatch) => {
  try {
    const res = await api.post('/payment/add', data);
    if (res.status === 201) dispatch({ type: ADD_PAYMENT_SUCCESS, payload: res.data.payment });
  } catch (e) {}
};

export const updatePayment = (id, data) => async (dispatch) => {
  try {
    const res = await api.patch(`/payment/update/${id}`, data);
    if (res.status === 200) dispatch({ type: UPDATE_PAYMENT_SUCCESS, payload: res.data.payment });
  } catch (e) {}
};

export const deletePayment = (id) => async (dispatch) => {
  try {
    await api.delete(`/payment/delete/${id}`);
    dispatch({ type: DELETE_PAYMENT_SUCCESS, payload: id });
  } catch (e) {}
};

export const generateMonthlyInvoices = (userId) => async (dispatch) => {
  try {
    const res = await api.post(`/payment/generate-invoices/${userId}`);
    if (res.data.created?.length > 0) {
      res.data.created.forEach(p => dispatch({ type: ADD_PAYMENT_SUCCESS, payload: p }));
    }
    return res.data;
  } catch (e) {}
};
